"use client";
import React from "react";
import Link from "next/link";
import { generatePathName } from "@packages/lib/utlils/filters/result-filters";
import { useFilterContext } from "@packages/lib/utlils/use-context/filter-context";
import Accordion from "@packages/shared-components/common-utilities/accordion/accordion";
import { setDocumentCookie } from "@packages/lib/utlils/cookie-utils";
const YearAndMonthAccordianFilter = ({
  jsondata,
  keyName,
  formUrl,
  appendSearchParams,
}: any) => {
  const { prepopulateFilter, setPrepopulateFilter, slug, filterState } =
    useFilterContext();
  const monthList = [
    { month: "All month" },
    ...(Array.isArray(jsondata?.intakeYearDetails?.intakeMonthList)
      ? jsondata.intakeYearDetails.intakeMonthList
      : []),
  ];

  const intakeYear = jsondata?.intakeYearDetails?.intakeYearList?.[0]?.year;
  setDocumentCookie({ name: "intakeYear", value: intakeYear });
  return (
    <>
      {(jsondata?.intakeYearDetails?.intakeYearList?.length > 0 ||
        jsondata?.intakeYearDetails?.intakeMonthList?.length > 0) && (
        <Accordion
          id="#year"
          title="Intake year"
          defaultOpenStatus={
            filterState?.selectedFilter === "all" ||
            filterState?.selectedFilter === "year"
          }
        >
          <div className="flex flex-col gap-[8px] p-[8px_0_0]">
            <div className="x-small font-semibold text-black uppercase">
              Choose MONTH
            </div>
            <div className="flex flex-wrap gap-x-[4px] gap-y-[8px]">
              {jsondata?.intakeYearDetails?.intakeYearList?.map(
                (yearItem: any, index: number) => (
                  <div className="form-black flex relative" key={index}>
                    <input
                      checked={true}
                      onChange={() => {}}
                      readOnly={true}
                      type="checkbox"
                      name={yearItem?.year}
                      className="rounded-[4px] outline-none absolute opacity-0"
                      id={yearItem?.year}
                    />
                    <label
                      htmlFor={yearItem?.year}
                      className="btn btn-black-outline"
                    >
                      {yearItem?.year}
                    </label>
                  </div>
                ),
              )}
            </div>
            <div className="flex flex-wrap gap-x-[4px] gap-y-[8px]">
              {monthList?.map((monthItem: any, index: any) => (
                <div className="form-black flex relative" key={index}>
                  {/* {monthItem?.month !== "All month" && (
                    <Link
                      className="hidden"
                      id={keyName?.month + monthItem?.month}
                      href={{
                        pathname: generatePathName(slug, keyName?.month),
                        query: formUrl(keyName?.month, monthItem?.month),
                      }}
                    >
                      {monthItem?.month}
                    </Link>
                  )} */}
                  <input
                    checked={
                      prepopulateFilter?.month?.toLowerCase() ==
                      monthItem?.month?.toLowerCase()
                    }
                    onChange={() => {
                      if (
                        monthItem?.month === "All month" &&
                        prepopulateFilter?.month === "All month"
                      ) {
                        return;
                      }
                      if (monthItem?.month === "All month") {
                        appendSearchParams(keyName?.month, "");
                        setPrepopulateFilter((prev: any) => ({
                          ...prev,
                          month: "All month",
                        }));
                        return;
                      }
                      appendSearchParams(keyName?.month, monthItem?.month);
                      setPrepopulateFilter((prev: any) => ({
                        ...prev,
                        month: monthItem?.month,
                      }));
                    }}
                    type="checkbox"
                    name={monthItem?.month}
                    className="rounded-[4px] outline-none absolute opacity-0"
                    id={monthItem?.month}
                  />
                  <label
                    htmlFor={monthItem?.month}
                    className="btn btn-black-outline min-w-[53px] py-[5px]"
                  >
                    {monthItem?.month}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </Accordion>
      )}
    </>
  );
};

export default YearAndMonthAccordianFilter;
